import { defineComponent as _defineComponent } from 'vue'
import { computed, useStore } from "@nuxtjs/composition-api";

import { useVuetify } from "@/composables";
import { getAmplitudeStore } from "@/store/amplitude";
import { getCollectionsStore } from "@/store/collections";
import { useCreatorShop } from "@/store/creator-shop";


export default /*#__PURE__*/_defineComponent({
  __name: 'LtkCollectionSlidegroup',
  props: {
  profileId: {
    type: String,
    required: true,
  },
  displayName: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const store = useStore();
const vuetify = useVuetify();

const MAX_NUM_OF_COLLECTIONS = 36;
const isSmall = computed(() => vuetify.breakpoint.smAndDown);
const hasCollections = computed(() => Boolean(collections.value.length > 0));
const showSeeAll = computed(() => collections.value.length >= MAX_NUM_OF_COLLECTIONS);

const collections = computed(() => {
  const collectionsStore = getCollectionsStore(store);
  const collectionIds = collectionsStore.creatorCollectionFeed(props.displayName)?.ids || [];
  return collectionIds.slice(0, MAX_NUM_OF_COLLECTIONS).map((collectionId) => ({
    id: collectionId,
    tile: {
      class: "mr-2",
      "ltk-ids": ltkIds.value(collectionId),
      title: collectionsStore.collections[collectionId]?.title,
      width: tileWidth.value,
      height: tileHeight.value,
      target: {
        name: "explore-displayName-collections-id",
        params: { displayName: props.displayName, id: collectionId },
      },
    },
    card: {
      class: "text-decoration-none mr-2",
      flat: true,
      width: 88,
      to: {
        name: "explore-displayName-collections-id",
        params: { displayName: props.displayName, id: collectionId },
      },
    },
    img: {
      "ltk-id": ltkIds.value(collectionId)[0],
      "has-link": false,
      outlined: true,
      width: 88,
      height: 88,
      experiment: true,
    },
    latestItemIds: collectionsStore.collections[collectionId]?.latestItemIds,
  }));
});

const ltkIds = computed(() => {
  return (collectionId: string) => {
    const collection = getCollectionsStore(store).collections[collectionId];
    const displayImages = 3;
    const latestItems = collection?.latestItemIds?.slice(0, displayImages) || [];
    return latestItems.map((item) => collection?.latestItemMap[item]?.externalId).filter((item) => !!item);
  };
});

const tileHeight = computed(() => {
  const smAndDownHeight = 168;
  const height = 156;
  return vuetify.breakpoint.smAndDown ? smAndDownHeight : height;
});

const tileWidth = computed(() => {
  const smAndDownWidth = 168;
  const xlWidth = 225;
  const width = 180;
  return vuetify.breakpoint.smAndDown ? smAndDownWidth : vuetify.breakpoint.xl ? xlWidth : width;
});

const setReferringComponentAndShopTab = () => {
  // This does not work with nuxt-link and @click.native despite that being the recommended approach https://github.com/vuejs/vue-router/issues/800
  getAmplitudeStore(store).setReferringComponent("creator shop collection carousel");
  useCreatorShop().setReferringShopTab();
};

return { __sfc: true,props, store, vuetify, MAX_NUM_OF_COLLECTIONS, isSmall, hasCollections, showSeeAll, collections, ltkIds, tileHeight, tileWidth, setReferringComponentAndShopTab }
}

})